// export const BASE_URL = "https://api.marryem.com:3001";
// export const BASE_URL = "https://api.marryem.com:3001";
// export const BASE_URL = "https://app.marryem.com:5000";
// export const BASE_URL = "https://api.marryem.com:3001";
// const BASE_DOMAIN = "http://localhost:5000";
// export const BASE_URL = "https://api.marryem.com/api/v1";
export const BASE_URL = "https://api.marryem.com/api/v1";
// export const BASE_URL = "http://localhost:5000/api/v1";
// export const BASE_URL = BASE_DOMAIN+"/api/v1";
// export const BASE_URL = BASE_DOMAIN;
// export const BASE_URL = "http://203.129.225.99:5000";

const ApiConfig = {
  BASE_URL_FOR_IMAGES_Profile: "https://api.marryem.com/",
  // BASE_URL_FOR_IMAGES: "https://api.marryem.com/uploads/articles/",
  BASE_URL_FOR_IMAGES: "https://api.marryem.com:3001/uploads/articles/",
  // BASE_URL: BASE_URL,
  //  ============= ADMIN API =============================
  LOGIN: BASE_URL + "/admin/login",
  ADD_UPDATE_ADMIN: BASE_URL + "/admin/addUpdate-admin",
  UPDATE_ADMIN: BASE_URL + "/admin/UpdateAdmin",
  ADMIN_DELETE: BASE_URL + "/admin/delete-admin",
  VERIFY_USER: BASE_URL + "/admin/verify-user",
  AI_REVIEW: BASE_URL + "/admin/review", // + /:phoneNumber and /:phoneNumber/run
  AI_REVIEW_CONFIG: BASE_URL + "/admin/review/config",
  ASSISTANT_CHAT: BASE_URL + "/admin/assistant/chat",
  // Dynamic filter/profile configuration (mobile filter screen + profile pickers)
  FILTER_CONFIG: BASE_URL + "/admin/filter-config",
  FILTER_CONFIG_RESET: BASE_URL + "/admin/filter-config/reset",
  FILTER_CONFIG_DEFAULTS: BASE_URL + "/admin/filter-config/defaults",
  // Which countries new members can sign up from (GET list / PUT { changes })
  SIGNUP_COUNTRIES: BASE_URL + "/admin/signup-countries",
  AD_PLANS: BASE_URL + "/admin/ad-plans", // + /:id for update
  VERIFY_DCOUMENT: BASE_URL + "/admin/verify-document",
  BLOCK_USER: BASE_URL + "/admin/block-user",
  USER_UNBLOCK: BASE_URL + "/users/block-unblock-user",
  VERIFY_DOC: BASE_URL + "/users/verify-doc",
  DASHBOARD_COUNT: BASE_URL + "/dashboard/content-count",
  DASHBOARD_USER_COUNT: BASE_URL + "/dashboard/user-count",
  PROFILE_SUGG: BASE_URL + "/prof-suggestion/suggest-user",

  GET_ALL_SUBSCRIPTION_PLANS : BASE_URL + "/subscription/plans",
  ADD_SUBSCRIPTION_PLAN : BASE_URL + "/subscription/plan",
  DELETE_SUBSCRIPTION_PLAN : BASE_URL + "/subscription/plan",

  // App config (store links), Content-backed
  STORE_LINKS: BASE_URL + "/content/store-links",

  // Matching Control Center — how compatibility is scored and how automatic
  // suggestions are generated. The AI matching instructions now live here too
  // (the old Content Management editor was retired); the backend still reads the
  // legacy Content row once, as a migration fallback.
  MATCHING_CONFIG: BASE_URL + "/admin/matching/config",
  MATCHING_CONFIG_RESET: BASE_URL + "/admin/matching/config/reset",
  MATCHING_DEFAULTS: BASE_URL + "/admin/matching/defaults",
  MATCHING_PREVIEW: BASE_URL + "/admin/matching/preview",
  MATCHING_SUGGESTIONS: BASE_URL + "/admin/matching/suggestions",
  MATCHING_SUGGESTIONS_RUN: BASE_URL + "/admin/matching/suggestions/run",
  MATCHING_RECOMPUTE: BASE_URL + "/admin/matching/recompute",

  // Optional Background Verification — request intake + admin workflow.
  VERIFICATION_LIST: BASE_URL + "/admin/verification",
  VERIFICATION_DETAIL: BASE_URL + "/admin/verification", // + /:id
  VERIFICATION_STATUS: BASE_URL + "/admin/verification", // + /:id/status
  VERIFICATION_MESSAGE: BASE_URL + "/admin/verification", // + /:id/message
  OPTIONAL_BACKGROUND_POLICY: BASE_URL + "/content/optional-background-policy",

  // RevenueCat (proxied server-side so the secret API key never reaches the browser)
  RC_OVERVIEW: BASE_URL + "/revenuecat/metrics/overview",
  RC_REVENUE: BASE_URL + "/revenuecat/metrics/revenue",
  RC_PRODUCTS: BASE_URL + "/revenuecat/products",
  RC_ENTITLEMENTS: BASE_URL + "/revenuecat/entitlements",
  RC_OFFERINGS: BASE_URL + "/revenuecat/offerings",
  RC_SYNC_STATUS: BASE_URL + "/revenuecat/sync-status",

  GET_SUBSCRIPTION_PLAN_MEMBERS: BASE_URL + "/admin/subscribe/get-users-by-plan",
  GET_UNIQUE_USER_BY_USERID: BASE_URL + "/admin/get-strangers",
  PERSIST_SUGGESTED_USERS_PREMIUM: BASE_URL + "/admin/subscribe/suggestion",

  //  ============= CONTENT_ MANEGMENT API =============================
  ADD_UPDATE_ARTICLES: BASE_URL  + "/articles/addUpdate-articles",
  UPDATE_ARTICLES: BASE_URL  + "/articles/update-article",
  ABOUT_ADDUPDATE: BASE_URL  + "/content/addUpdate-contents",
  QUERY_RESPONSE: BASE_URL  + "/query-mgmt/query-response",
  ARTICLE_DELTE: "/articles/delete-article",

  //  =============Subject API =============================
  ADD_SUBJECT: BASE_URL + "/subject/add-subject",
  SUBJECT_LIST: BASE_URL + "/subject/view-subjects",
  UPDATE_SUBJECT: BASE_URL + "/subject/update-subject",
  DELETE_SUBJECT: BASE_URL + "/subject/delete-subject",
  SUBJECT_ACTIVE: BASE_URL + "/subject/activeInactive-subject",

  USERS_LIST : BASE_URL + "/account/list-users",
  USER_DETAILS: BASE_URL+"/admin/users",

  ACTIVE_USER_COUNT : BASE_URL + "/user-activity/active-users",
  CAMPAIGN_LIST : BASE_URL + "/campaign/all",
  USER_RETENTION : BASE_URL + "/dashboard/retention-rate",

  UPDATE_AD_CAMPAIGN : BASE_URL + "/ad-campaign/update",
  DELETE_AD_CAMPAIGN : BASE_URL + "/ad-campaign/delete"
};

export default ApiConfig;
